import MailIcon from "@/assets/icons/envelope.svg";
import IconBall from "@components/IconBall";
import Modal, { ModalContent } from "@components/Modal";
import { ModalProps } from "@components/Modal/Modal";
import Typography from "@components/Typography";

import styles from "./ContactSalesModal.module.css";

const ContactSalesModal = (props: Omit<ModalProps, "children">) => {
  return (
    <Modal {...props}>
      <ModalContent>
        <div className={styles.center}>
          <IconBall icon={MailIcon} />
          <Typography variant="h1">
            {L.CONTACT_SALES_MESSAGE_CONFIRMATION_TITLE}
          </Typography>
          <Typography variant="h5" align="center">
            {L.CONTACT_SALES_MESSAGE_CONFIRMATION_SUBTITLE}
          </Typography>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default ContactSalesModal;
